<template>
  <div class="animation" ref="animation"></div>
</template>

<script>
import animation from '@/mixins/animation';
import feetPos from '@/assets/animations/feetpos.json';

export default {
  name: 'FeetPos',
  mixins: [animation],
  data: () => ({
    animationData: feetPos,
    autoPlay: true,
  }),
};
</script>

<style lang="scss" scoped></style>
